/** @format */

export const PrintSmall = ({color}) => {
    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M13.25 6.25H2.75C1.7834 6.25 1 7.03477 1 8V10.625C1 11.1082 1.39184 11.5 1.875 11.5H2.75V14.125C2.75 14.6082 3.14184 15 3.625 15H12.375C12.8582 15 13.25 14.6082 13.25 14.125V11.5H14.125C14.6082 11.5 15 11.1082 15 10.625V8C15 7.03477 14.2152 6.25 13.25 6.25ZM11.5 13.25H4.5V10.625H11.5V13.25ZM12.8125 9.09375C12.4502 9.09375 12.1562 8.7998 12.1562 8.4375C12.1562 8.07465 12.4502 7.78125 12.8125 7.78125C13.1748 7.78125 13.4688 8.07465 13.4688 8.4375C13.4688 8.80117 13.1762 9.09375 12.8125 9.09375ZM4.5 2.75H10.7754L11.5 3.47488V5.375H13.25V3.1123C13.25 2.88032 13.1577 2.65785 12.9937 2.49379L11.7563 1.25648C11.593 1.09229 11.3687 1 11.1391 1H3.625C3.14211 1 2.75 1.39184 2.75 1.875V5.375H4.5V2.75Z"
                fill={color}
            />
        </svg>
    );
};
